import { Entity } from 'src/app/core/utils/entity';

export abstract class ClaimEntity extends Entity {
  constructor(
    public department_id: string,
    public claimetLastname: string,
    public claimetName: string,
    public claimetCuil: string,
    public claimetEmail: string,
    public claimetPhone: string,
    public claimetProvince: string,
    public claimetCity: string,
    public claimetNeighborhood: string,
    public claimetStreet: string,
    public claimetNumber: string,
    public claimetPostalCode: string,
    public claimetSelectedTypeOfJob: string,
    public consent: boolean,
    public claimetWorkday: string,
    public claimetGrossRemuneration: string,
    public claimetTypeRemuneration: string,
    public claimetDateAdmission: Date,
    public claimetCurrentEmploymentStatus: string,
    public claimetFileDni: string[],
    public claimetFilePaycheck: string[],
    public claimedTypeOfPerson: string,
    public claimedNameLastNameOrBusinessName: string,
    public claimedCuil: string,
    public claimedEmail: string,
    public claimedPhone: string,
    public claimedStreet: string,
    public claimedNumber: string,
    public claimedPostalCode: string,
    public claimedNeighborhood: string,
    public claimedProvince: string,
    public claimedCity: string,
    public selecterObjectOfClaim: string | string[],
    public textClaimDetails: string,
    public extraDocumentationPdf: string,
    public selectedOwnRight: string,
    public lawyerFullName: string,
    public lawyerRegistrationNumber: string,
    public lawyerEmail: string,
    public user_id: string,
    public claimetFloorApartament?: string,
    public claimetTower?: string,
    public confirmInformation?: boolean,
    public claimetEgressDate?: Date,
    public claimetReasonForDisengagement?: string,
    public claimetCauseDisengagement?: string,
    public claimedFloorApartment?: string,
    public claimedTower?: string,
    public proceedings?: string,
    public expediente_claim?: string,
    public number_of_claim?: string,
    public status?: string,
    public created?: string,
    public reasonForRejection?: string,
    public conciliatorId?: string,
    public conciliatorFullName?: string,
    public is_borrador?: boolean,
    public department_number?: string,
    public department_name?: string,
    public id?: string,
    public Rol?: string,
    public company_email?: string,
    public claimetCompany?: string,
    public claimetTypePerformance?: string,
    public claimetPosition?: string,
    public claimetCompanyPhone?: string,
    public claimetCompanyCuit?: string,
    public claimetStreetUser?: string,
    public claimetNumberUser?: string,
    public claimetFloorApartmentUser?: string,
    public claimetPostalCodeUser?: string,
    public claimetLocalityUser?: string,
    public claimetProvinceUser?: string,
    public claimetBirthDateUser?: string,
    public audience_id?: string,
    public date_audience?: string,
    public time_audience?: string,
    //Datos user gremial
    public type_of_representation?: string,
    public representativeLastName?: string,
    public representativeName?: string,
    public representativeCuil?: string,
    public representativeEmail?: string,
    public representativePhone?: string,
    public representativeStreet?: string,
    public representativeNumber?: string,
    public representativeFloorApartment?: string,
    public representativeTower?: string,
    public representativePostalCode?: string,
    public representativeProvince?: string,
    public representativeCity?: string
  ) {
    super();
  }
}
